import React from 'react';
import SeoLandingPage, { SeoLandingContent } from './SeoLandingPage';

const content: SeoLandingContent = {
  path: '/jobber-alternative',
  title: 'Jobber Alternative for Lawn Care | LawnHub',
  description:
    'Looking for a Jobber alternative for lawn care? LawnHub offers CRM, scheduling, crews, and payments with no forced monthly subscription — plus optional marketplace leads.',
  keywords:
    'Jobber alternative, Jobber alternative for lawn care, lawn care software like Jobber, Yardbook alternative, landscaping software alternative',
  h1: 'A Jobber Alternative Built for Lawn Care Operators',
  subhead:
    'If you want scheduling, CRM, and crew tools without stacking another expensive monthly plan — LawnHub is built for lawn care and snow removal businesses that want to keep more of what they earn.',
  sections: [
    {
      heading: 'What providers usually want from a Jobber-class tool',
      body: 'Owners compare lawn care software for the same core jobs: quote and schedule work, manage customers, run crews, and get paid. LawnHub covers that ops stack and adds optional marketplace demand when you want new customers.',
      bullets: [
        'Customer CRM and service history',
        'Scheduling and route optimization',
        'Mobile crew workflows',
        'Payments, payouts, and financial visibility',
      ],
    },
    {
      heading: 'Where LawnHub is different',
      body: 'Many top-tier field-service subscriptions charge hundreds per month before you earn a dollar on the platform. LawnHub focuses on completed work: bring your own customers at 1%, use marketplace leads at transparent fees, and skip forced subscription tiers just to unlock basics.',
      bullets: [
        'No forced monthly subscription to run your book of business',
        '1% on customers you onboard; marketplace leads use clear first-season fees',
        'Customers pay card processing separately — not taken from your cut the same way opaque stacks often feel',
        'Optional growth via marketplace bids when you want them',
      ],
    },
    {
      heading: 'Honest comparison notes',
      body: 'Jobber and similar tools are strong products with deep feature sets. LawnHub is not claiming to clone every add-on overnight. We focus on the lawn care operator workflow — CRM, scheduling, crews, payments, financial reporting — with a fee model that rewards bringing your own customers. Use the Provider Savings Snapshot on our homepage to estimate subscription and fee differences for your revenue.',
    },
  ],
  faq: [
    {
      q: 'Is LawnHub a free Jobber replacement?',
      a: 'LawnHub is not a free clone. It is an ops platform with no forced monthly subscription; you pay platform fees when jobs complete. Many providers switch because the total cost structure fits better than a high monthly SaaS bill.',
    },
    {
      q: 'Can I move my existing customers off Jobber-style tools onto LawnHub?',
      a: 'Yes. You can onboard existing customers and run scheduling, CRM, and payments on LawnHub while keeping those relationships.',
    },
    {
      q: 'Does LawnHub include marketing or AI receptionist add-ons?',
      a: 'LawnHub prioritizes core operations and optional marketplace leads. Feature scope differs from every Jobber plan add-on; evaluate against the workflows you actually use day to day.',
    },
  ],
  relatedLinks: [
    { label: 'Lawn care CRM', to: '/lawn-care-crm' },
    { label: 'Lawn care scheduling software', to: '/lawn-care-scheduling-software' },
    { label: 'Provider benefits', to: '/provider-benefits' },
    { label: 'Provider Savings Snapshot', to: '/' },
  ],
};

const JobberAlternativePage: React.FC = () => <SeoLandingPage content={content} />;

export default JobberAlternativePage;
